import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { exam } from "../../../../core/data/json/exam";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";
import Spin from "antd/es/spin";
import { Button, Checkbox, CheckboxChangeEvent, Input, Select } from "antd";
import { CloseCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { FilterDropdownProps } from "antd/es/table/interface";

type Permission = { id: number; name: string };
type Admin = {
  id: number;
  phone_number: string;
  name: string;
  email: string;
  lead_source: string;
  notes: string;
  address: string;
};

type Agent = {
  id: number;
  username: string;
};

type Category = {
    category_id: number,
    category_name: string,
}

type SubCategory = {
    subcategory_id: number,
    subcategory_name: string,
}

const { Option } = Select;

const CompletedCallParticipantList = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const data = exam;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${month}-${day}-${year}`;
  const defaultValue = dayjs(formattedDate);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [admin, setAdmin] = useState<Admin[]>([]);
  const [from, setFrom] = useState();
  const [to, setTo] = useState<number>();
  const [totalCount, setTotalCount] = useState();
  const [toastMessage, setToastMessage] = useState("");
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [searchText, setSearchText] = useState<string>("");
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const [AsignshowCard, setAsignShowCard] = useState(false);
  const [agentsLoading, setAgentsLoading] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState<string[]>([]);
  const [agentsDropdown, setAgentsDropdown] = useState<Agent[]>([]);
  const [categories, setCategories] = useState<Category[]>([]);
  const [subCategories, setSubCatergories] = useState<SubCategory[]>([]);
  const [agentsFilterDropdown, setAgentsFilterDropdown] = useState<Agent[]>([]);
  const [selectedAgentFilter, setSelectedAgentFilter] = useState<number>(() => {
    const saved = localStorage.getItem("CallParticipentselectedAgentFilter");
    return saved !== null ? Number(saved) : 0;
  });
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };
  const [selectedCategory, setSelectedCategory] = useState<number>(
    Number(localStorage.getItem('callParticipantDailedselectedCategory')) || 0
  );
  const [selectedSubCategory, setSelectedSubCaatgery] = useState<number>(
    Number(localStorage.getItem('callParticipantDailedSelectedSubCategory')) || 0
  );
  const handleClearSubCategory = () => setSelectedSubCaatgery(0);
  const handleClearCategory = () => setSelectedCategory(0);
  useEffect(() => {
    localStorage.setItem('callParticipantDailedselectedCategory', selectedCategory.toString());
  }, [selectedCategory]);
  useEffect(() => {
    localStorage.setItem('callParticipantDailedSelectedSubCategory', selectedSubCategory.toString());
  }, [selectedSubCategory]);
  // const [scsSearchText, setScsSearchText] = useState("");
  // const [nameSearchText, setNameText] = useState("");
  // const [branchSearchText, setBranchText] = useState("");
  // const [phoneSearchText, setPhoneText] = useState("");
  // const [orientationSearchText, setOrientationText] = useState("");
  const [scsSearchText, setScsSearchText] = useState<string>(
    () => localStorage.getItem("scsSearchText") || ""
  );

  const [nameSearchText, setNameText] = useState<string>(
    () => localStorage.getItem("nameSearchText") || ""
  );

  const [branchSearchText, setBranchText] = useState<string>(
    () => localStorage.getItem("branchSearchText") || ""
  );

  const [phoneSearchText, setPhoneText] = useState<string>(
    () => localStorage.getItem("phoneSearchText") || ""
  );

  const [orientationSearchText, setOrientationText] = useState<string>(
    () => localStorage.getItem("orientationSearchText") || ""
  );
  useEffect(() => {
    localStorage.setItem("scsSearchText", scsSearchText);
  }, [scsSearchText]);

  useEffect(() => {
    localStorage.setItem("nameSearchText", nameSearchText);
  }, [nameSearchText]);

  useEffect(() => {
    localStorage.setItem("branchSearchText", branchSearchText);
  }, [branchSearchText]);

  useEffect(() => {
    localStorage.setItem("phoneSearchText", phoneSearchText);
  }, [phoneSearchText]);

  useEffect(() => {
    localStorage.setItem("orientationSearchText", orientationSearchText);
  }, [orientationSearchText]);

  const handleClearAgent = () =>
    setSelectedAgentFilter(0);
  useEffect(() => {
    localStorage.setItem(
      "CallParticipentselectedAgentFilter",
      selectedAgentFilter.toString()
    );
  }, [selectedAgentFilter]);
  useEffect(() => {
    if (!checkPermission("view_callparticipant", "callparticipant")) {
      navigate(routes.adminDashboard);
    } else {
      fetchData(currentPage, pageSize, searchText);
      fetchAgentsData();
      fetchAgentFilterData();
      fetchCategories();
    }
  }, [userPermissions]);


   const fetchCategories = async () => {
        try {
            const response = await fetch(
                `${webApi}/callparticipant/call_participant_category_dropdown/`,
                options
            );
            const data = await response.json();
            setCategories(data);
        } catch (error) {
            console.error("Failed to fetch agents", error);
        }
    }

    const fetchSubCategories = async () => {
        try {
            let apiUrl = `${webApi}/callparticipant/subcategories_dropdown/`;
            if (selectedCategory) apiUrl += `?category_id=${selectedCategory}`;
            const response = await fetch(
                apiUrl,
                options
            );
            const data = await response.json();
            setSubCatergories(data);
        } catch (error) {
            console.error("Failed to fetch agents", error);
        }
    }

     useEffect(() => { fetchSubCategories() }, [selectedCategory]);


  useEffect(() => {
    fetchData(currentPage, pageSize, searchText);
  }, [selectedAgentFilter, scsSearchText, nameSearchText, branchSearchText, phoneSearchText, orientationSearchText, searchText, currentPage, pageSize,selectedCategory,selectedSubCategory]);

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchAgentFilterData = async () => {
    const response = await fetch(
      `${webApi}/teammgmt/get_team_members_by_user_with_extra_agent/`,
      options
    );
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/login");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    const data = await response.json();
    setAgentsFilterDropdown(data);
  }

  const fetchAgentsData = async () => {
    setAgentsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/teammgmt/get_team_members_by_user_all_teams/`,
        options
      );
      const data = await response.json();
      setAgentsDropdown(data);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    } finally {
      setAgentsLoading(false);
    }
  };

  const fetchGroupsData = async (
    page: number,
    pageSize: number,
    searchText: string
  ) => {
    let apiUrl = `${webApi}/callparticipant/completed_call_participant/?page=${page}&page_size=${pageSize}&search=${searchText}`;
    if (selectedAgentFilter !== 0) {
      apiUrl += `&agent=${selectedAgentFilter}`;
    }
    if (scsSearchText) {
      apiUrl += `&admission_number=${scsSearchText}`;
    }
    if (nameSearchText) {
      apiUrl += `&name=${nameSearchText}`;
    }
    if (branchSearchText) {
      apiUrl += `&branch_name=${branchSearchText}`;
    }
    if (phoneSearchText) {
      apiUrl += `&phone_number=${phoneSearchText}`;
    }
    if (orientationSearchText) {
      apiUrl += `&orientation_name=${orientationSearchText}`;
    }
    if (selectedCategory !== 0) {
      apiUrl += `&category=${selectedCategory}`;
    }
    if (selectedSubCategory !== 0) {
      apiUrl += `&subcategory=${selectedSubCategory}`;
    }
    const response = await fetch(
      apiUrl,
      options
    );
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/login");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };

  const fetchPermissionsData = async () => {
    const resposne = await fetch(
      `${webApi}/user/get_permissions_dropdown/`,
      options
    );
    return await resposne.json();
  };

  const fetchData = async (
    page: number,
    pageSize: number,
    searchText: string
  ) => {
    setIsLoading(true); // Start loading
    try {
      const [groupsData,] = await Promise.all([
        fetchGroupsData(page, pageSize, searchText),
        // fetchPermissionsData(),
      ]);
      setTotalPages(groupsData.total_pages);
      setAdmin(groupsData.results);
      // setPermissions(permissionsData.results);

      setFrom(groupsData.from);
      setTo(groupsData.to);
      setTotalCount(groupsData.total_count);
      setToastMessage(groupsData.message || "submitted successfully!");
      setShowSuccessToast(true);
      setTotalCount(groupsData.total_count);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);
    // fetchData(current, pageSize, searchText); // Fetch new data based on the updated pagination
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    // fetchData(currentPage, pageSize, value);
  };

  const handleSelect = (
    student_id: any,
    selectedRowKeys: string[],
    setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    const selectedIds = [...selectedRowKeys];
    const index = selectedIds.indexOf(student_id);
    if (index >= 0) {
      selectedIds.splice(index, 1);
    } else {
      selectedIds.push(student_id);
    }
    setSelectedRowKeys(selectedIds);
  };

  const handleSelectAll = (
    e: CheckboxChangeEvent,
    data: { id: any }[],
    setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    if (e.target.checked) {
      const allIds = data.map((item) => item.id);
      setSelectedRowKeys(allIds);
    } else {
      setSelectedRowKeys([]);
    }
  };

  const handleAgentAssignment = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setAgentsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/callparticipant/change_participant_agent/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({
            participant_ids: selectedRowKeys,
            agent: selectedAgent,
            // target_date_: targetDate,
          }),
        }
      );

      const data = await response.json();
      if (!response.ok) {
        // setDangerToastMessage(data.message);
        // setShowSolidDangerToast(true);
        // throw new Error("Failed to assign agent");
      }

      console.log("Agent assigned successfully", data);
      setToastMessage(data.message);
      // setshowSolidSuccessToast(true);
      setSelectedRowKeys([]);
      setSelectedAgent([]);
      // setTargetDate("");

      setAsignShowCard(false);
    } catch (error) {
      console.error("Failed to assign agent", error);
    } finally {
      setAgentsLoading(false);
      fetchData(currentPage, pageSize, searchText);
    }
  };

  const handleSelectChange = (value: string[]) => {
    setSelectedAgent(value);
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "action",
      render: (_text: any, record: { id: any }) => (
        <Checkbox
          checked={selectedRowKeys.includes(record.id)}
          onChange={() =>
            handleSelect(record.id, selectedRowKeys, setSelectedRowKeys)
          }
        />
      ),
      key: "action",
      // align: "center",
    },
    {
      title: (
        <span>
          SCS Number
          {scsSearchText && (
            <span style={{ marginLeft: 8, display: "inline-flex", alignItems: "center" }}>
              <span style={{ color: "#1890ff", marginRight: 4 }}>({scsSearchText})</span>
              <CloseCircleOutlined
                onClick={() => {
                  setScsSearchText("");
                }}
                style={{ color: "red", cursor: "pointer" }}
              />
            </span>
          )}
        </span>
      ),
      dataIndex: "admission_number",
      key: "admission_number",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: FilterDropdownProps) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            placeholder="Search SCS Number"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => {
              confirm();
              setScsSearchText(selectedKeys[0] as string);
            }}
            style={{ marginBottom: 8, display: "block" }}
          />
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { id: any }
      ) => (
        <Link
          to={`${routes.addOrUpdateCallParticipantTicket}?id=${record.id}&s1=2`}
        >
          {text}
        </Link>
      ),
    },
    {
      title: (
        <span>
          Name
          {nameSearchText && (
            <span style={{ marginLeft: 8, display: "inline-flex", alignItems: "center" }}>
              <span style={{ color: "#1890ff", marginRight: 4 }}>({nameSearchText})</span>
              <CloseCircleOutlined
                onClick={() => {
                  setNameText("");
                }}
                style={{ color: "red", cursor: "pointer" }}
              />
            </span>
          )}
        </span>
      ),
      dataIndex: "name",
      key: "name",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: FilterDropdownProps) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            placeholder="Search Name"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => {
              confirm();
              setNameText(selectedKeys[0] as string);
            }}
            style={{ marginBottom: 8, display: "block" }}
          />
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { id: any }
      ) => (
        <Link
          to={`${routes.addOrUpdateCallParticipantTicket}?id=${record.id}&s1=2`}
        >
          {text}
        </Link>
      ),
    },
    {
      title: (
        <span>
          Branch
          {branchSearchText && (
            <span style={{ marginLeft: 8, display: "inline-flex", alignItems: "center" }}>
              <span style={{ color: "#1890ff", marginRight: 4 }}>({branchSearchText})</span>
              <CloseCircleOutlined
                onClick={() => {
                  setBranchText("");
                }}
                style={{ color: "red", cursor: "pointer" }}
              />
            </span>
          )}
        </span>
      ),
      dataIndex: "branch_name",
      key: "branch_name",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: FilterDropdownProps) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            placeholder="Search Branch"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => {
              confirm();
              setBranchText(selectedKeys[0] as string);
            }}
            style={{ marginBottom: 8, display: "block" }}
          />
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { id: any }
      ) => (
        <Link
          to={`${routes.addOrUpdateCallParticipantTicket}?id=${record.id}&s1=2`}
        >
          {text}
        </Link>
      ),
    },
    {
      title: (
        <span>
          Phone Number
          {phoneSearchText && (
            <span style={{ marginLeft: 8, display: "inline-flex", alignItems: "center" }}>
              <span style={{ color: "#1890ff", marginRight: 4 }}>({phoneSearchText})</span>
              <CloseCircleOutlined
                onClick={() => {
                  setPhoneText("");
                }}
                style={{ color: "red", cursor: "pointer" }}
              />
            </span>
          )}
        </span>
      ),
      dataIndex: "phone_number",
      key: "phone_number",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: FilterDropdownProps) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            placeholder="Search Phone Number"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => {
              confirm();
              setPhoneText(selectedKeys[0] as string);
            }}
            style={{ marginBottom: 8, display: "block" }}
          />
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { id: any }
      ) => (
        <Link
          to={`${routes.addOrUpdateCallParticipantTicket}?id=${record.id}&s1=2`}
        >
          {text}
        </Link>
      ),
    },
    {
      title: (
        <span>
          Orientation
          {orientationSearchText && (
            <span style={{ marginLeft: 8, display: "inline-flex", alignItems: "center" }}>
              <span style={{ color: "#1890ff", marginRight: 4 }}>({orientationSearchText})</span>
              <CloseCircleOutlined
                onClick={() => {
                  setOrientationText("");
                }}
                style={{ color: "red", cursor: "pointer" }}
              />
            </span>
          )}
        </span>
      ),
      dataIndex: "orientation_name",
      key: "orientation_name",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: FilterDropdownProps) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            placeholder="Search Orientation"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => {
              confirm();
              setOrientationText(selectedKeys[0] as string);
            }}
            style={{ marginBottom: 8, display: "block" }}
          />
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { id: any }
      ) => (
        <Link
          to={`${routes.addOrUpdateCallParticipantTicket}?id=${record.id}&s1=2`}
        >
          {text}
        </Link>
      ),
    },
    // {
    //   title: "Phone Number",
    //   dataIndex: "phone_number",
    //   render: (
    //     text:
    //       | string
    //       | number
    //       | boolean
    //       | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    //       | Iterable<React.ReactNode>
    //       | React.ReactPortal
    //       | null
    //       | undefined,
    //     record: { id: any }
    //   ) => (
    //     <Link
    //       to={`${routes.addOrUpdateCallParticipantTicket}?id=${record.id}&s1=1`}
    //     >
    //       {text}
    //     </Link>
    //   ),
    // },
    // {
    //   title: "Email",
    //   dataIndex: "email",
    //   render: (
    //     text:
    //       | string
    //       | number
    //       | boolean
    //       | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    //       | Iterable<React.ReactNode>
    //       | React.ReactPortal
    //       | null
    //       | undefined,
    //     record: { id: any }
    //   ) => (
    //     <Link
    //       to={`${routes.addOrUpdateCallParticipantTicket}?id=${record.id}&s1=1`}
    //     >
    //       {text}
    //     </Link>
    //   ),
    // },
    // {
    //   title: "Lead Source",
    //   dataIndex: "lead_source",
    //   render: (
    //     text:
    //       | string
    //       | number
    //       | boolean
    //       | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    //       | Iterable<React.ReactNode>
    //       | React.ReactPortal
    //       | null
    //       | undefined,
    //     record: { id: any }
    //   ) => (
    //     <Link
    //       to={`${routes.addOrUpdateCallParticipantTicket}?id=${record.id}&s1=1`}
    //     >
    //       {text}
    //     </Link>
    //   ),
    // },
    // {
    //   title: "Address",
    //   dataIndex: "address",
    //   render: (
    //     text:
    //       | string
    //       | number
    //       | boolean
    //       | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    //       | Iterable<React.ReactNode>
    //       | React.ReactPortal
    //       | null
    //       | undefined,
    //     record: { id: any }
    //   ) => (
    //     <Link
    //       to={`${routes.addOrUpdateCallParticipantTicket}?id=${record.id}&s1=1`}
    //     >
    //       {text}
    //     </Link>
    //   ),
    // },
    {
      title: (
        <span>
          Category{selectedCategory !== 0 ? ` (${categories.find(state => state.category_id === selectedCategory)?.category_name})` : ""}
          {selectedCategory !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearCategory}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "category_name",
      key: "category_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Category"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = categories.find((s) => s.category_id === value);
              setSelectedKeys(selected ? [selected.category_name] : []);
              setSelectedCategory(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {categories.map((state) => (
              <Select.Option key={state.category_id} value={state.category_id}>
                {state.category_name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { department_name: string }) => record.department_name === value,
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { id: any }
      ) => (
        <Link
          to={`${routes.addOrUpdateCallParticipantTicket}?id=${record.id}&s1=1`}
        >
          {text}
        </Link>
      ),
    },
    {
      title: (
        <span>
          Sub Category{selectedSubCategory !== 0 ? ` (${subCategories.find(state => state.subcategory_id === selectedSubCategory)?.subcategory_name})` : ""}
          {selectedSubCategory !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearSubCategory}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "subcategory_name",
      key: "subcategory_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Sub Category"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = subCategories.find((s) => s.subcategory_id === value);
              setSelectedKeys(selected ? [selected.subcategory_name] : []);
              setSelectedSubCaatgery(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {subCategories.map((state) => (
              <Select.Option key={state.subcategory_id} value={state.subcategory_id}>
                {state.subcategory_name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { department_name: string }) => record.department_name === value,
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { id: any }
      ) => (
        <Link
          to={`${routes.addOrUpdateCallParticipantTicket}?id=${record.id}&s1=1`}
        >
          {text}
        </Link>
      ),
    },
    {
      title: (<span>
        Agent
        <span>

          {selectedAgentFilter !== 0
            ? ` (${agentsFilterDropdown.find(
              (state) =>
                state.id === selectedAgentFilter
            )?.username
            })`
            : ""}
          {selectedAgentFilter !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearAgent}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>
      </span>),
      dataIndex: "agent_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Previous Orientation"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = agentsFilterDropdown.find(
                (s) => s.id === value
              );
              setSelectedKeys(selected ? [selected.username] : []);
              setSelectedAgentFilter(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === "string" &&
              (option.children as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {agentsFilterDropdown.map((state) => (
              <Select.Option
                key={state.id}
                value={state.id}
              >
                {state.username
                }
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { id: any }
      ) => (
        <Link
          to={`${routes.addOrUpdateCallParticipantTicket}?id=${record.id}&s1=1`}
        >
          {text}
        </Link>
      ),
    },
    // {
    //   title: "Action",
    //   dataIndex: "action",
    //   render: (_text: any, record: { id: any }) => (
    //     <div className="d-flex align-items-center">
    //       {checkPermission("change_callparticipant", "callparticipant") && (
    //         <Link
    //           className="btn btn-icon btn-sm btn-soft-info rounded-pill"
    //           to={routes.editCallParticipant}
    //           state={{ id: record.id }}
    //         >
    //           <i className="feather-edit" />
    //         </Link>
    //       )}
    //     </div>
    //   ),
    // },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Completed Call Participants</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    List
                  </li>
                </ol>
              </nav>
            </div>
            {/* <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="mb-2">
                {checkPermission("add_callparticipant", "callparticipant") && (
                  <Link to={routes.addCallParticipant} className="btn btn-primary">
                    <i className="ti ti-square-rounded-plus-filled me-2" />
                    Add Participant
                  </Link>
                )}
              </div>
            </div> */}
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div
            className="card "
            style={{
              width: "100%",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              borderRadius: "10px",
            }}
          >
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Call Participants List</h4>
              <div className="d-flex align-items-center flex-wrap ms-auto">
                <Checkbox
                  indeterminate={
                    selectedRowKeys.length > 0 &&
                    selectedRowKeys.length < admin.length
                  }
                  checked={selectedRowKeys.length === admin.length}
                  onChange={(e) =>
                    handleSelectAll(e, admin, setSelectedRowKeys)
                  }
                >
                  Select All
                </Checkbox>

                {checkPermission("change_agent", "Records") && (
                  <button
                    className="btn btn-primary"
                    onClick={() => setAsignShowCard(true)}
                    disabled={selectedRowKeys.length === 0}
                    style={{ marginLeft: "10px", marginBottom: "5px" }}
                  >
                    Assign Agent
                  </button>
                )}
              </div>
            </div>
            <div className="card-body p-0 py-3">
              <div
                className="serch-global text-right"
                style={{ marginRight: "15px" }}
              >
                <input
                  type="search"
                  className="form-control form-control-sm mb-3 w-auto float-end"
                  value={searchText}
                  placeholder="Search"
                  onChange={(e) => handleSearch(e.target.value)}
                  aria-controls="DataTables_Table_0"
                ></input>
              </div>
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin />{" "}
                  {/* Display loader while loading */}
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={admin}
                  Selection={false}
                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    locale: { items_per_page: "" },
                    nextIcon: <span>Next</span>,
                    prevIcon: <span>Prev</span>,
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    total: totalCount,
                    showTotal: (total: any, range: any[]) => `${range[0]}-${range[1]} of ${total}`,
                    pageSizeOptions: ["10", "20", "30", "50", "100"],
                  }}
                  onChange={handleTableChange} // Move this outside of pagination
                  onSearch={handleSearch}
                />)}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      {AsignshowCard && (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 1049,
            }}
          />
          <div
            className="card"
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "20%",
              boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
              borderRadius: "10px",
              zIndex: 1050,
              backgroundColor: "#f9f9f9",
              padding: "20px",
            }}
          >
            <form onSubmit={handleAgentAssignment}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label
                        className="form-label"
                        style={{
                          paddingBottom: "10px",
                          fontWeight: "bold",
                          color: "#555",
                        }}
                      >
                        Select Agent
                      </label>
                      {agentsLoading ? (
                        <Spin />
                      ) : (
                        <Select
                          // mode="multiple" 
                          value={selectedAgent}
                          onChange={handleSelectChange}
                          style={{
                            width: "100%",
                          }}
                          showSearch
                          filterOption={(input, option) => {
                            if (!option || !option.children) return false; // Check if option or option.children is undefined
                            const label = option.children as unknown as string; // Ensure that option.children is treated as a string
                            return label
                              .toLowerCase()
                              .includes(input.toLowerCase());
                          }}
                        >
                          {agentsDropdown.map((agent) => (
                            <Option key={agent.id} value={agent.id}>
                              {agent.username}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </div>
                    {/* <div className="mb-3">
                              <label
                                className="form-label"
                                style={{
                                  paddingBottom: "10px",
                                  fontWeight: "bold",
                                  color: "#555",
                                }}
                              >
                                Target Date
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                value={targetDate}
                                onChange={(e) => setTargetDate(e.target.value)}
                                required
                              />
                            </div> */}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <Button
                  className="btn btn-light me-2"
                  onClick={() => setAsignShowCard(false)}
                >
                  Cancel
                </Button>
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={agentsLoading}
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </>
      )}
      <>
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
      </>
    </div>
  );
};

export default CompletedCallParticipantList;
